export default __webpack_public_path__ + "static/2-60a26ac039ac4274658d552d7437ce31.png";